// Jquery
var $ = jQuery;


$(document).ready(function(){

	//Hamburger icon
	$('.main-navigation-hamburger').click(function(){
		$(this).toggleClass('open');
		$('.main-navigation-row').toggleClass('auto-height');
		$('.main-navigation-column').toggleClass('active');

		if ($('.main-navigation-column')[0].style.maxHeight) {
			$('.main-navigation-column')[0].style.maxHeight = null;
		} else if($('.pll-parent-menu-item').find('.sub-menu').length >= 1) {
			$('.main-navigation-column')[0].style.maxHeight = $('.main-navigation-column')[0].scrollHeight + $('.pll-parent-menu-item').find('.sub-menu')[0].scrollHeight + "px";
		} else {
			$('.main-navigation-column')[0].style.maxHeight =$('.main-navigation-column')[0].scrollHeight + "px";
		}
	});

	//Submenu
	$('.menu-item-object-page').hover(function(){
		if($(this).hasClass('menu-item-has-children')) {
			if ($(this).find('.sub-menu')[0].style.height) {
				$(this).find('.sub-menu')[0].style.height = null;
			} else {
				$(this).find('.sub-menu')[0].style.height = $(this).find('.sub-menu')[0].scrollHeight + "px";
			}
		}
	});

	//Language switcher
	if($('.pll-parent-menu-item').find('.sub-menu').length < 1) {
		$('.pll-parent-menu-item').addClass('not-available');
	}
	
	$('.pll-parent-menu-item').click(function(){
		$(this).find('a').toggleClass('open');
		if ($(this).find('.sub-menu')[0].style.height) {
			$(this).find('.sub-menu')[0].style.height = null;
		} else {
			$(this).find('.sub-menu')[0].style.height = $(this).find('.sub-menu')[0].scrollHeight + "px";
		}
	});

	let langs = $('.pll-parent-menu-item').find('span');


	//Scroll nav
	$('.page-hero-nav-link').click(function(){
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top-40
	}, 1000);
	});

	// $(".btn-tab-nav a").click(function(){
	// 	$(this).tab('show');
	// });

	$('.btn-outline-toggle').click(function(){
	if(!$('#cabinet-sn2').hasClass('active')) {
		$('#sn2-text').removeClass('d-none');
		$('#sn3-text').addClass('d-none');
	} else if(!$('#cabinet-sn3').hasClass('active')) {
		$('#sn3-text').removeClass('d-none');
		$('#sn2-text').addClass('d-none');
	}
});

});


// WEBPACK FOOTER //
// ./assets/js/scripts/scripts.js